<template>
    <div>
        <canvas :id="sigid" class="sigcanvas"/>
        <linkbutton toplabel="clear" @click="clear"/>
        
    </div>
    
  
  </template>
  
  <script>
  import SignaturePad from 'signature_pad'
  import linkbutton from './linkbutton.vue'
  import format from '../../format.js'
  export default {
      name:"signaturepadlight",
      components:{
          linkbutton
      },
      mixins:[format],
      data() {
          return {
              outImgUrl:null,
              imageBlob:null,
              signaturePad:null
          };
      },
      props: {
          
          enteredName:{
            type:String,
            default:''
          },
          docName:{
            type:String,
            default:''
          },
          sigid:{
            type:String,
            default:'canvas'
          }
  
      },
      mounted(){
        //   var canvas = document.querySelector(this.sigid)
        var canvas = document.querySelector(`#${this.sigid}`)
          this.signaturePad=new SignaturePad(canvas)
          window.addEventListener("resize", this.resizeCanvas);
          this.resizeCanvas();
      },
      methods:{
          resizeCanvas(){
               var canvas = document.querySelector(`#${this.sigid}`)
              var ratio =  Math.max(window.devicePixelRatio || 1, 1);
              canvas.width = canvas.offsetWidth * ratio;
              canvas.height = canvas.offsetHeight * ratio;
              canvas.getContext("2d").scale(ratio, ratio);
              this.signaturePad.clear(); // otherwise isEmpty() might return incorrect value
          },
         
          clear(){
              this.signaturePad.clear();
          },
         
      
      }
  }
  </script>
  
  <style>
  .sigcanvas{
     
      width:100%;
      border:1px solid black;
      height:100px;
  }
  </style>